import { GQL } from '../graphQl'
export const createConfigurationRuleMutation = () => GQL`mutation createConfigurationRuleMutation($input: [validations_insert_input!]!) {
  insert_validations(objects: $input) {
    returning {
      id
    }
  }
}`
export const DeleteAndCreateConfigurationRuleMutation = () => GQL`mutation DeleteAndCreateConfigurationRuleMutation($validationIds: [uuid!]) {
delete_validations(where: {id: {_in: $validationIds}}) {
affected_rows
}
}
`
export const getRulesQuery = () => GQL`query GetValidations {
  validations(where: {type: {_eq: "EXECUTION"}}, order_by: {created_on: desc}) {
    target
    name
    created_on
    id
    trigger_actions {
      trigger_action
      id
      metadata
      sequence_template_id
      core_sequence_id_template {
        id
        name
      }
    }
    validation_groups(order_by: {sequence: asc}) {
      id
      operator_to_next_group
      sequence
      type
      validation_conditions {
        bool_value
        date_value
        id
        int_list
        int_value
        left_operand
        operator
        source
        string_list
        string_value
      }
    }
  }
}
 `
export const GetStandardMaterialFormFields = () => GQL`query GetStandardMaterialFormFields($fieldIds: [uuid!]!,$templateVersionId: uuid!) {
  template_fields_aggregate(where: {field_id: {_in: $fieldIds}, template_version_id: {_eq:$templateVersionId}}) {
    aggregate {
      count(columns: field_id)
    }
  }
}`
